import $ from 'jquery';
import ComponentBasePrototype from 'ComponentBasePrototype';
import RequestUtils from '../../../base/request/request';

export default class TvChannelPackageList extends ComponentBasePrototype {
  build() {
    this.tags = this.node.find('.cms-tv-channel-package-list__tag-container-tag');
    this.heroButton = this.node.find('.image-hero__texts--anchor-button .button');
    this.showMoreTags = this.node.find('.cms-tv-channel-package-list__tag-container-show-more');
    this.activeTagClass = 'cms-tv-channel-package-list__tag-container-tag--selected';
    this.tablistLabelSelector = '.cms-tablist__label';
    this.tablistLabelActiveClass = 'cms-tablist__label--active';
    this.tablistTagLabelSelector = '.cms-tv-channel-package-list__tag-container-tag';
    this.tablistTagLabelActiveClass = 'cms-tv-channel-package-list__tag-container-tag--active';
    this.urlCategory = this.node.find('#category').val();
    this.urlTag = this.node.find('#tag').val();
    this.visibleTagChunkIndex = [];

    this.requestIsRunning = false;

    if (!this.visibleTagChunkIndex[this.urlCategory]) {
      this.visibleTagChunkIndex[this.urlCategory] = 0;
      $(`#show-more-tags-${this.urlCategory}`).show();
    }

    this.showNextTagsChunk();

    if (document.documentElement.clientWidth >= 601) {
      this.showNextTagsChunk();
    }

    this.addEventHandlers();
  }

  addEventHandlers() {
    this.addTagClickListener();
    this.addShowMoreTagsClickListener();
    this.addCategoryClickListener();

    if (this.heroButton) {
      this.addButtonClickListener();
    }
  }

  addButtonClickListener() {
    this.heroButton.on('click', (event) => {
      event.preventDefault();

      const content = this.node.find('#tv-channel-package-list__container')[0];
      const navigationHeight = this.getNavigationHeight();

      window.scrollTo({
        top: content.offsetTop - navigationHeight,
        left: 0,
        behavior: 'smooth',
      });
    });
  }

  addTagClickListener() {
    this.tags.on('click', (event) => {
      if (this.requestIsRunning) {
        event.preventDefault();
        return;
      }

      // prevent multi click
      if (event.detail <= 1) {
        this.requestIsRunning = true;
        const input = $(`input[id=${$(event.currentTarget).attr('aria-controls')}]`)[0];

        if (this.urlTag === input.value) {
          event.preventDefault();
          let newUrl;

          newUrl = this.removeEndingSlashFromUrl(window.location.href);
          newUrl = this.removeParameterFromPrettyUrl(newUrl, this.urlTag);

          history.pushState(null, null, newUrl);
          input.checked = false;

          this.reloadContainers();
        } else {
          this.appendTagUrlParameter(input.value);
          this.setActiveTab(event.currentTarget, 'tag');
        }

        if (this.heroButton) {
          this.addButtonClickListener();
        }
      }
    });
    this.setKeyDownEvent(this.tags, 'tag');
  }

  addShowMoreTagsClickListener() {
    this.showMoreTags.on('click', () => {
      const showMoreTagsButton = $(`#show-more-tags-${this.urlCategory}`);
      if (!this.visibleTagChunkIndex[this.urlCategory]) {
        this.visibleTagChunkIndex[this.urlCategory] = 0;
        showMoreTagsButton.show();
      }
      this.showNextTagsChunk();
    });
  }

  showNextTagsChunk() {
    this.visibleTagChunkIndex[this.urlCategory] += 1;
    const activeCategoryTags = this.tags.filter(
      (i, t) =>
        $(t)
          .attr('aria-controls')
          .startsWith(this.urlCategory) && this.urlCategory !== '',
    );
    const tagsToShow = activeCategoryTags.filter(
      `.cms-tv-channel-package-list__tag-container-tag--${this.visibleTagChunkIndex[this.urlCategory]}`,
    );
    if (
      activeCategoryTags.filter(`.cms-tv-channel-package-list__tag-container-tag--${this.visibleTagChunkIndex[this.urlCategory] + 1}`)
        .length === 0
    ) {
      $(`#show-more-tags-${this.urlCategory}`).hide();
    }

    tagsToShow.show();
  }

  addCategoryClickListener() {
    const tabLabels = this.node.find(this.tablistLabelSelector);

    tabLabels.on('click', (event) => {
      if (this.requestIsRunning) {
        event.preventDefault();
        return;
      }

      // prevent multi click
      if (event.detail <= 1) {
        this.requestIsRunning = true;

        const currentCategory = RequestUtils.getQueryParam('category') ? RequestUtils.getQueryParam('category') : this.urlCategory;
        const currentTag = RequestUtils.getQueryParam('tag') ? RequestUtils.getQueryParam('tag') : this.urlTag;
        const newCategory = $(event.target).attr('id');
        const newCategoryTags = $(`input[name=tag-${newCategory}]`);

        newCategoryTags.each((i) => {
          newCategoryTags[i].checked = false;
        });

        this.setActiveTab(event.target, 'category');

        let newUrl;
        let currentUrl = window.location.href;
        let hasAnalytics = false;
        let analyticsTags = '';

        if (currentUrl.indexOf('?') !== -1) {
          hasAnalytics = true;
          analyticsTags = currentUrl.substring(currentUrl.indexOf('?'));
          currentUrl = currentUrl.substring(0, currentUrl.indexOf('?'));
        }

        newUrl = this.removeEndingSlashFromUrl(currentUrl);
        newUrl = this.removeParameterFromPrettyUrl(newUrl, currentTag);
        newUrl = this.removeParameterFromPrettyUrl(newUrl, currentCategory);
        newUrl = this.addParameterToPrettyUrl(newUrl, newCategory);

        if (hasAnalytics) {
          newUrl += analyticsTags;
        }

        history.pushState(null, null, newUrl);
        this.reloadContainers();
      }

      $(window).on('popstate', () => {
        this.heroContainer.load(`${window.location.href} #tv-channel-package-list-hero`);
        this.textContainer.load(`${window.location.href} #tv-channel-package-list-text`);
        this.channelPackageList.load(`${window.location.href} #tv-channel-package-list`, () => {
          this.urlCategory = this.node.find('#category').val();
          this.urlTag = this.node.find('#tag').val();

          let activeTab = this.node.find(`.cms-tablist__label#${this.urlCategory}`);

          if (activeTab.length === 0) {
            activeTab = this.node.find('.cms-tablist__label')[0];
          }

          this.setActiveTab(activeTab, 'category');

          if (this.urlTag) {
            const newTagInput = $(`input[id=${this.urlCategory}-${this.urlTag}]`)[0];
            if (newTagInput) {
              newTagInput.checked = true;
            }
          } else {
            const newCategoryTags = $(`input[name=tag-${this.urlCategory}]`);

            $(`input[name=tag-${this.urlCategory}]`).each((i) => {
              newCategoryTags[i].checked = false;
            });
          }
        });
      });
    });
    this.setKeyDownEvent(tabLabels, 'category');
  }

  setKeyDownEvent(node, type) {
    node.on('keydown', (event) => {
      const currentTab = $(event.target);
      let newTab;
      const currentIndex = node.index(currentTab);
      switch (event.key) {
        case 'ArrowLeft':
          newTab = node.eq(currentIndex - 1);
          if (newTab.length === 0) {
            newTab = node.last();
          }
          break;
        case 'ArrowRight':
          newTab = node.eq(currentIndex + 1);
          if (newTab.length === 0) {
            newTab = node.first();
          }
          break;
        default:
          return;
      }
      if (newTab.length > 0) {
        newTab.focus();
        this.setActiveTab(newTab[0], type);
        newTab[0].click();
      }
      event.preventDefault();
    });
  }

  setActiveTab(target, type) {
    this.removeAllActiveClasses(type);
    this.addActiveClassToTab(target, type);
    this.activateSelectedRadioButton(target);
  }

  removeAllActiveClasses(type) {
    if (type === 'category') {
      this.node.find(this.tablistLabelSelector).removeClass(this.tablistLabelActiveClass);
    } else {
      this.node.find(this.tablistTagLabelSelector).removeClass(this.tablistTagLabelActiveClass);
    }
  }

  addActiveClassToTab(target, type) {
    if (type === 'category') {
      $(target).addClass(this.tablistLabelActiveClass);
    } else {
      $(target).addClass(this.tablistTagLabelActiveClass);
    }
  }

  activateSelectedRadioButton(target) {
    const radioButtonId = $(target).attr('aria-controls');
    const radioButton = this.node.find(`#${radioButtonId}`);
    radioButton.prop('checked', true).trigger('click');
  }

  removeEndingSlashFromUrl(url) {
    return url.replace(/\/+$/, '');
  }

  addParameterToPrettyUrl(url, parameter) {
    return parameter ? url.concat(`/${parameter}`) : url;
  }

  appendTagUrlParameter(newTag) {
    const oldTag = RequestUtils.getQueryParam('tag') ? RequestUtils.getQueryParam('tag') : this.urlTag;

    let newUrl;
    let currentUrl = window.location.href;
    let hasAnalytics = false;
    let analyticsTags = '';

    if (currentUrl.indexOf('?') !== -1) {
      hasAnalytics = true;
      analyticsTags = currentUrl.substring(currentUrl.indexOf('?'));
      currentUrl = currentUrl.substring(0, currentUrl.indexOf('?'));
    }

    newUrl = this.removeEndingSlashFromUrl(currentUrl);
    newUrl = this.removeParameterFromPrettyUrl(newUrl, oldTag);
    newUrl = this.addParameterToPrettyUrl(newUrl, newTag);

    if (hasAnalytics) {
      newUrl += analyticsTags;
    }

    history.pushState(null, null, newUrl);
    this.reloadContainers();
  }

  removeParameterFromPrettyUrl(url, parameter) {
    const splittedUrl = url.split('/');

    if (splittedUrl[splittedUrl.length - 1] === parameter) {
      splittedUrl.pop();
    }

    return splittedUrl.join('/');
  }

  getNavigationHeight() {
    const navigationNode = $('.navigation__top-bar');

    if (navigationNode.length) {
      return navigationNode.height();
    }

    return 0;
  }

  reloadContainers() {
    this.heroContainer = this.node.find('#tv-channel-package-list-hero__container');
    this.textContainer = this.node.find('#tv-channel-package-list-text__container');
    this.channelPackageList = this.node.find('#tv-channel-package-list__container');

    this.heroContainer.load(`${window.location.href} #tv-channel-package-list-hero`, () => {
      this.heroButton = this.node.find('.image-hero__texts--anchor-button .button');

      if (this.heroButton) {
        this.addButtonClickListener();
      }
    });

    this.textContainer.load(`${window.location.href} #tv-channel-package-list-text`);

    this.channelPackageList.load(`${window.location.href} #tv-channel-package-list`, () => {
      this.urlCategory = this.node.find('#category').val();
      this.urlTag = this.node.find('#tag').val();
      this.requestIsRunning = false;

      if (!this.visibleTagChunkIndex[this.urlCategory]) {
        this.visibleTagChunkIndex[this.urlCategory] = 0;
        $(`#show-more-tags-${this.urlCategory}`).show();

        this.showNextTagsChunk();
      }
    });
  }
}
